import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  class: "ticker-content",
  style: {"height":"100%"}
}
const _hoisted_2 = {
  key: 0,
  class: "ticker-separator-container"
}
const _hoisted_3 = {
  class: "ticker-item",
  style: { gap: '16px', minHeight: '40px' }
}
const _hoisted_4 = { class: "currency-container" }
const _hoisted_5 = ["src"]
const _hoisted_6 = {
  class: "ticker-values",
  style: { gap: '15px' }
}
const _hoisted_7 = { class: "value-container" }
const _hoisted_8 = { class: "value-container" }
const _hoisted_9 = {
  class: "ticker-content",
  "aria-hidden": "true",
  style: {"height":"100%"}
}
const _hoisted_10 = { class: "ticker-separator-container" }
const _hoisted_11 = {
  class: "ticker-item",
  style: { gap: '16px', minHeight: '40px' }
}
const _hoisted_12 = { class: "currency-container" }
const _hoisted_13 = ["src"]
const _hoisted_14 = {
  class: "ticker-values",
  style: { gap: '15px' }
}
const _hoisted_15 = { class: "value-container" }
const _hoisted_16 = { class: "value-container" }

import { ref, onMounted, computed, onBeforeUnmount } from "vue";
import { displayService } from '@/_services';


const __default__ = {
  name: "ExchangeTicker",
};


export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    config: {},
    backgroundColor: {},
    valuesColor: {},
    textColor: {},
    flagTxtColor: {},
    separator: {},
    separatorColor: {},
    separatorPadding: {},
    tickerSpeed: {}
  },
  setup(__props: any) {

const props = __props;

const ticker = ref<any[]>([]);
const isOnline = ref(navigator.onLine);

const codeToFlag = {
  USD: 'us',
  EUR: 'eu',
  GBP: 'gb',
  JPY: 'jpy',
  CAD: 'ca',
  CHF:'ch',
  AED:'aed',
  SAR:'sa',
  QAR:'qa',
  KWD:'kw',
  BHD:'bh',
  LYD:'lyd',
  CNY:'cny',
};

const saveToLocalStorage = (data: any[]) => {
  try {
    localStorage.setItem('exchangeData', JSON.stringify(data));
    localStorage.setItem('exchangeDataTimestamp', Date.now().toString());
  } catch (error) {
    console.error('Error saving to localStorage:', error);
  }
};

const loadFromLocalStorage = () => {
  try {
    const data = localStorage.getItem('exchangeData');
    const timestamp = localStorage.getItem('exchangeDataTimestamp');
    
    if (data && timestamp) {
      const parsedData = JSON.parse(data);
      const dataAge = Date.now() - parseInt(timestamp);
      
      // Only use cached data if it's less than 24 hours old
      if (dataAge < 24 * 60 * 60 * 1000) {
        return parsedData;
      }
    }
    return null;
  } catch (error) {
    console.error('Error loading from localStorage:', error);
    return null;
  }
};

const getExchangeData = async () => {
  try {
    if (isOnline.value) {
      const response = await displayService.getExchangeData();
      const changes = response.changes || [];
      const updatedTicker = await Promise.all(
        changes.map(async (item: any) => {
          let flagSrc = '';
          try {
            const code = String(item.code);
            const flagFile = (codeToFlag as Record<string, string>)[code] || code.toLowerCase();
            const flagModule = await import(`@/assets/images/flags/${flagFile}.svg`);
            flagSrc = flagModule.default;
          } catch (error) {
            flagSrc = '';
          }
          return {
            ...item,
            flagSrc,
          };
        })
      );
      ticker.value = updatedTicker;
      saveToLocalStorage(updatedTicker);
    } else {
      const cachedData = loadFromLocalStorage();
      if (cachedData) {
        ticker.value = cachedData;
      } else {
        ticker.value = [{
          code: 'SERVICE',
          sell: 'MOMENTANEMENT',
          buy: 'INDISPONIBLE',
          flagSrc: ''
        }];
      }
    }
  } catch (err) {
    console.error("Error loading exchange data:", err);
    const cachedData = loadFromLocalStorage();
    if (cachedData) {
      ticker.value = cachedData;
    } else {
      ticker.value = [{
        code: 'SERVICE',
        sell: 'MOMENTANEMENT',
        buy: 'INDISPONIBLE',
        flagSrc: ''
      }];
    }
  }
};

const updateOnlineStatus = () => {
  isOnline.value = navigator.onLine;
  console.log(`Connection status changed: ${isOnline.value ? "Online" : "Offline"}`);
  getExchangeData();
};

const formatNumber = (num: number) => {
  return Math.trunc(num * 1000) / 1000;
}

// responsive sizing
const flagHeight = computed(() => {
  const height = props.config?.height || 40;
  return Math.floor(height * 0.625); // 62.5% of the ticker height
});

const flagWidth = computed(() => {
  const height = props.config?.height || 40;
  return Math.floor(height); // 100% of the ticker height
});

const codeFontSize = computed(() => {
  const height = props.config?.height || 40;
  return Math.floor(height * 0.35) + 'px'; // 35% of the ticker height
});

const valueFontSize = computed(() => {
  const height = props.config?.height || 40;
  return Math.floor(height * 0.45) + 'px'; // 45% of the ticker height
});

const labelFontSize = computed(() => {
  const height = props.config?.height || 40;
  return Math.floor(height * 0.3) + 'px'; //30% of the ticker height
});

onMounted(() => {
  updateOnlineStatus();
  window.addEventListener('online', updateOnlineStatus);
  window.addEventListener('offline', updateOnlineStatus);
});

onBeforeUnmount(() => {
  window.removeEventListener('online', updateOnlineStatus);
  window.removeEventListener('offline', updateOnlineStatus);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "exchange-ticker-widget",
    style: _normalizeStyle({
      backgroundColor: _ctx.backgroundColor,
      fontSize: valueFontSize.value,
      overflow: 'hidden',
      alignItems: 'center',
      display: 'flex',
    })
  }, [
    _createElementVNode("div", {
      class: "ticker-track-horizontal",
      style: _normalizeStyle({ animationDuration: _ctx.tickerSpeed + 's', height: '100%' })
    }, [
      _createElementVNode("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(ticker.value, (item, index) => {
          return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
            (index > 0)
              ? (_openBlock(), _createElementBlock("span", _hoisted_2, [
                  _createElementVNode("span", {
                    class: "ticker-separator",
                    style: _normalizeStyle({
                color: _ctx.separatorColor,
                padding: `0 ${_ctx.separatorPadding}px`,
              })
                  }, _toDisplayString(_ctx.separator), 5)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("span", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                (item.flagSrc)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      src: item.flagSrc,
                      class: "ticker-flag-img",
                      alt: "flag",
                      style: _normalizeStyle({ height: flagHeight.value + 'px', width: flagWidth.value + 'px' })
                    }, null, 12, _hoisted_5))
                  : _createCommentVNode("", true),
                _createElementVNode("span", {
                  class: "ticker-code",
                  style: _normalizeStyle({ color: _ctx.flagTxtColor, fontSize: codeFontSize.value, fontWeight: 'bold' })
                }, _toDisplayString(item.code), 5)
              ]),
              _createElementVNode("span", _hoisted_6, [
                _createElementVNode("span", _hoisted_7, [
                  _createElementVNode("span", {
                    class: "ticker-value",
                    style: _normalizeStyle({ color: _ctx.valuesColor, fontSize: valueFontSize.value, fontWeight: 'bold' })
                  }, _toDisplayString(item.buy), 5),
                  _createElementVNode("span", {
                    class: "value-label",
                    style: _normalizeStyle({ color: _ctx.textColor, fontSize: labelFontSize.value, textTransform: 'uppercase' })
                  }, "ACHAT", 4)
                ]),
                _createElementVNode("span", _hoisted_8, [
                  _createElementVNode("span", {
                    class: "ticker-value",
                    style: _normalizeStyle({ color: _ctx.valuesColor, fontSize: valueFontSize.value, fontWeight: 'bold' })
                  }, _toDisplayString(item.sell), 5),
                  _createElementVNode("span", {
                    class: "value-label",
                    style: _normalizeStyle({ color: _ctx.textColor, fontSize: labelFontSize.value, textTransform: 'uppercase' })
                  }, "VENTE", 4)
                ])
              ])
            ])
          ], 64))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_9, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(ticker.value, (item, index) => {
          return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
            _createElementVNode("span", _hoisted_10, [
              _createElementVNode("span", {
                class: "ticker-separator",
                style: _normalizeStyle({
                color: _ctx.separatorColor,
                padding: `0 ${_ctx.separatorPadding}px`,
              })
              }, _toDisplayString(_ctx.separator), 5)
            ]),
            _createElementVNode("span", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                (item.flagSrc)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      src: item.flagSrc,
                      class: "ticker-flag-img",
                      alt: "flag",
                      style: _normalizeStyle({ height: flagHeight.value + 'px', width: flagWidth.value + 'px' })
                    }, null, 12, _hoisted_13))
                  : _createCommentVNode("", true),
                _createElementVNode("span", {
                  class: "ticker-code",
                  style: _normalizeStyle({ color: _ctx.flagTxtColor, fontSize: codeFontSize.value, fontWeight: 'bold' })
                }, _toDisplayString(item.code), 5)
              ]),
              _createElementVNode("span", _hoisted_14, [
                _createElementVNode("span", _hoisted_15, [
                  _createElementVNode("span", {
                    class: "ticker-value",
                    style: _normalizeStyle({ color: _ctx.valuesColor, fontSize: valueFontSize.value, fontWeight: 'bold' })
                  }, _toDisplayString(item.buy), 5),
                  _createElementVNode("span", {
                    class: "value-label",
                    style: _normalizeStyle({ color: _ctx.textColor, fontSize: labelFontSize.value, textTransform: 'uppercase' })
                  }, "Achat", 4)
                ]),
                _createElementVNode("span", _hoisted_16, [
                  _createElementVNode("span", {
                    class: "ticker-value",
                    style: _normalizeStyle({ color: _ctx.valuesColor, fontSize: valueFontSize.value, fontWeight: 'bold' })
                  }, _toDisplayString(item.sell), 5),
                  _createElementVNode("span", {
                    class: "value-label",
                    style: _normalizeStyle({ color: _ctx.textColor, fontSize: labelFontSize.value, textTransform: 'uppercase' })
                  }, "Vente", 4)
                ])
              ])
            ])
          ], 64))
        }), 128))
      ])
    ], 4)
  ], 4))
}
}

})